import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getIdData, addData, updateData } from "../../../lib/counselorcorner";
import { getAllData, getIdData as getInstroctorData } from '../../../lib/instructorinfo';
import { getAllData as getAllStudentData } from '../../../lib/studentinfo';
import { getInstructorStudent } from "../../../lib/instructorstudentview";
import { useAuth } from "../../../usercontext";

function GlobalCounselorCornerEdit({ slugFrom, isAdmin }) {
  const { slug, status, id } = useParams();
  const [data, setData] = useState({});
  const [ndate, setNdate] = useState();
  const [instructorId, setInstructorId] = useState();
  const [studentId, setStudentId] = useState();
  const [note, setNote] = useState();
  const [instructorName, setInstructorName] = useState("");
  const [selectedStudent, setSelectedStudent] = useState();
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [students, setStudents] = useState([]);
  const navigate = useNavigate();
  const { profile } = useAuth();
  const date = new Date(Date.now()).toLocaleDateString("en-CA");

  useEffect(() => {
    if (status === "Update") {
      const fetchNoteData = async () => {
        const notesData = await getIdData(id);
        const note = notesData[0];
        setData(note);
        setNdate(note.ndate);
        setInstructorId(note.instructorId);
        setStudentId(note.studentId);
        setNote(note.note);
      };
      fetchNoteData();
    }
  }, [status, id]);

  useEffect(() => {
    if (isAdmin && instructorId) {
      const fetchInstructorName = async () => {
        const instructor = await getInstroctorData(instructorId);
        console.log('instructor 1: ', instructor)
        setInstructorName(instructor[0]?.name || "");
      };
      fetchInstructorName();
    } else if (!isAdmin && slug) {
      const fetchInstructorName = async () => {
        const instructor = await getInstroctorData(slug);
        setInstructorName(instructor[0]?.name || "");
      };
      fetchInstructorName();
    }
  }, [instructorId, slug, isAdmin]);

  useEffect(() => {
    const fetchInstructorStudentData = async () => {
      const students = await getInstructorStudent(profile.id);
      setInstructorStudent(students);
    };
    fetchInstructorStudentData();
  }, [profile.id]);

  useEffect(() => {
    const fetchInstructors = async () => {
      const instructors = await getAllData();
      console.log('instructors: ', instructors)
      setInstructors(instructors);
    };
    fetchInstructors();

    const fetchStudents = async () => {
      const students = await getAllStudentData();
      setStudents(students);
    };
    fetchStudents();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('instructor 2: ', instructorId)
    console.log('slug 2: ', slug)
    const taskData = status === "Add" ? {
      ndate: date,
      instructorId: isAdmin ? instructorId : slug,
      studentId,
      note, } : {
      id,
      ndate: ndate,
      instructorId: isAdmin ? instructorId : slug,
      studentId,
      note,
     }

    try {
      if (status === "Add") {
        await addData(taskData);
      } else {
        await updateData(taskData);
      }
      navigate(-1);
    } catch (error) {
      console.error("There was an error saving the task!", error);
    }
  };

  return (
    <div className="container mt-2">
      <div className="comman-space card wish-card">
      <h3>{status === "Add" ? "Add Counselor Note" : "Update Counselor Note"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            value={status === "Add" ? date : ndate}
            onChange={(e) => setNdate(e.target.value)}
            required
          />
        </div>

        {isAdmin ? (
          <div className="form-group">
            <label>Written By</label>
            <select
              value={instructorId}
              onChange={(e) => setInstructorId(e.target.value)}
              className="select-box"
            >
              <option value="">Select An Instructor</option>
              {instructors.map((data, ix) => (
                <option key={ix} value={data.id}>
                  {data.name + " " + data.surname}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className="form-group">
            <label>Written By</label>
            <input
              type="text"
              className="form-control"
              value={instructorName}
              readOnly
            />
          </div>
        )}

        <div className="form-group">
          <label>Student</label>
          <select
            value={studentId}
            onChange={(e) => setStudentId(e.target.value)}
            className="select-box"
          >
            <option value="">Select A Student</option>
            {(isAdmin ? students : instructorStudent).map((data, ix) => (
              <option key={ix} value={isAdmin ? data.id : data.studentId}>
                {data.name + " " + data.surname}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Note</label>
          <textarea name="text" 
          rows={3}
                              value={note}
                              onChange={(e) => setNote(e.target.value)}
                              className="form-control" required></textarea>
        </div>

        <div className="update-profile d-flex justify-content-between">
          <button type="submit" className="btn btn-primary">
            {status === "Add" ? "Add" : "Update"}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
      </div>
    </div>
  );
}

export default GlobalCounselorCornerEdit;
